import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, size, space } from '../../theme/tokens';

export const FieldWrapper = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
  width: ${(p) => (p.$fullWidth ? '100%' : 'auto')};
`;

export const FieldLabel = styled.label`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const RequiredMark = styled.span`
  color: ${semantic.text.danger};
  margin-left: ${space['space-050']};
`;

export const TextInput = styled.input`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  padding: ${layout.inputPadding};
  border: 1px solid ${semantic.border.default};
  border-radius: ${size.radius['radius-xs']};
  color: ${semantic.text.primary};
  outline: none;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    border-color: ${colors.primary};
  }

  &[aria-invalid='true'] {
    border-color: ${semantic.border.danger};
  }
`;

export const Select = styled.select`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  padding: ${layout.inputPadding};
  border: 1px solid ${semantic.border.default};
  border-radius: ${size.radius['radius-xs']};
  color: ${semantic.text.primary};
  background: ${semantic.bg.canvas};
  outline: none;
  width: 100%;
  box-sizing: border-box;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  padding-right: ${space['space-900']};

  &:focus {
    border-color: ${colors.primary};
  }
`;

export const FormLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['space-400']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: 1fr 1fr;
    gap: ${space['space-600']};
  }
`;

export const FormLayoutFullWidth = styled.div`
  grid-column: 1 / -1;
`;
